import { atomFamily } from "recoil";

export const AtomFormState = atomFamily({
  key: "AtomFormStateForMode", // this must be unique and static
  default: { Mode: "Truck", Freight_Type: "" },
});
